//react
import React, { Component } from 'react';

//assets
import './languageTabs.css';

class LanguageTabs extends Component {
	render() {
		if (this.props.translations.length < 2) {
			return null;
		}

		const languageTabs = this.props.translations.map((language, index) => {
			const tabClassName = ['language-tabs__tab'];

			if (index === this.props.languageIndex) {
				tabClassName.push('language-tabs__tab--active');
			}

			return (
				<button className={tabClassName.join(' ')} key={index} onClick={() => this.props.changeLanguage(index)}>{language.language}</button>
			);
		});

		return (
			<div className="language-tabs">
				{languageTabs}
			</div>
		);
	}
}

export default LanguageTabs;



// WEBPACK FOOTER //
// ./src/components/languageTabs/languageTabs.js